module.exports = __webpack_public_path__ + "media/src/images/search/image-9a6b25b6423ea7bab0c39b6def1ed37f.jpg";